// M1 captcha (NHA VRFY_ABHA_301) error codes. Each ABHA flow shows these by the captcha box, not in its
// error banner. A pure helper (no API import), so the flows never depend on the API module for it.
export const CAPTCHA_ERROR_CODES = ['CAPTCHA_REQUIRED', 'CAPTCHA_INVALID', 'CAPTCHA_UNAVAILABLE'];
export const isCaptchaError = (err) => CAPTCHA_ERROR_CODES.includes(err?.abhaCode);
